import React from 'react';

function MapIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <g clipPath="url(#clip0_4214_34009)">
        <path
          fill="#049B56"
          d="M20.68 1.82l-.021-.007-2.715-.9a5.017 5.017 0 00-2.9-.08l-5.576 1.62a3.025 3.025 0 01-2.048-.18l-.5-.232A5 5 0 000 6.653v12.075a5.013 5.013 0 003.6 4.8l2.869.9c.484.15.988.226 1.495.225.452.006.902-.055 1.336-.181l5.8-1.6a3 3 0 011.617.013l2.343.676A4 4 0 0024 19.674V6.529a5.01 5.01 0 00-3.32-4.71zM4.176 21.612A3.014 3.014 0 012 18.728V6.653a2.953 2.953 0 011.336-2.5A3 3 0 015 3.653a2.9 2.9 0 011.112.222s.745.319.887.37v18.25l-2.823-.883zM9 22.48V4.532c.34-.018.677-.07 1.006-.155L15 2.926v17.927L9 22.48zm13-2.806a2 2 0 01-2.433 1.954L17 20.905V2.728l3.018.979A3.006 3.006 0 0122 6.529v13.145z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_4214_34009">
          <path fill="#fff" d="M0 0H24V24H0z" transform="translate(0 .652)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default MapIcon;
